import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '@shared/services/loading.service';

@Component({
  selector: 'app-loading-overlay',
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loading.component.css',
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);
  isLoading = this.loadingService.loadingSubject.asReadonly();
}
